import { useEffect, useState } from "react";
import * as AgenticV2API from "@/services/api/agentic-v2";
import type { AgentSummary } from "@/services/api/agentic-v2";

/**
 * Loads the company agent directory once (for resolving mission assignees in lists).
 */
export function useAgentsList(): AgentSummary[] {
  const [agents, setAgents] = useState<AgentSummary[]>([]);

  useEffect(() => {
    let mounted = true;
    AgenticV2API.listAgents()
      .then((rows) => {
        if (mounted) setAgents(rows);
      })
      .catch(() => {
        // Non-critical — list rows fall back to agent counts / "Unassigned".
      });
    return () => {
      mounted = false;
    };
  }, []);

  return agents;
}
